var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "COURIER_ENVIROTAINER",
    transform: "matrix(1.1,0,0,1.1,-80,-80)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M170.9,272.8c39.5-10.7,62.8-51.5,52.1-91c-0.9-3.2-2.2-6-3.4-8.9c12.6-3.4,22.8-6.2,27.3-7.4 c17.1-4.6-27.9-25-49.5-22.1c-17.8-14.1-41.7-20.1-65.4-13.6c-39.5,10.7-62.8,51.5-52.1,90.9C90.7,260.2,131.4,283.5,170.9,272.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M450.3,398c-0.9,0.1-80.7,5.9-117.9,6l-89.6-66c-10.8-27.4-33.1-42.8-66.7-38.4 c-43.3,5.5-73.9,45.1-68.4,88.4l13.8,105.6l139.2-6.4l-6.5-70l51.7,38.1c4.6,3.4,10.2,5.4,15.9,5.5c2.8,0.1,6,0.2,9.6,0.2 c39.8,0,119.5-5.9,123.2-6.1c15.7-1.2,27.5-14.8,26.3-30.5C479.6,408.6,465.7,396.7,450.3,398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M547.1,130.7H318.8c-3.5,0-6.4,2.9-6.4,6.4v203.8c0,3.5,2.9,6.4,6.4,6.4h228.3c3.5,0,6.4-2.9,6.4-6.4 V137.1C553.5,133.6,550.6,130.7,547.1,130.7z M518.6,312.6c0,1.6-1.3,2.9-2.9,2.9h-62.6c-1.6,0-2.9-1.3-2.9-2.9v-24.3 c0-1.6,1.3-2.9,2.9-2.9h62.6c1.6,0,2.9,1.3,2.9,2.9V312.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.ba0ff4beee8a4c5e31b8473cf2fa9837.svg";
export { ForwardRef as ReactComponent };